// extracted by mini-css-extract-plugin
export default {"autoComplete":"PostalCodeFields_autoComplete__ch1y-"};